import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getUser,
} from '../user/userSlice';
import {
  fetchAllProducts,
  getProducts,
  initCheckout,
  fetchSubscription,
  getSubscription,
  getIsLoadingSubscription
} from './paymentsSlice';
import AccountDetails from './AccountDetails';
import PaymentPortalLink from './PaymentPortalLink';
import Loader from '../../components/Loader';

function Pricing () {

  const dispatch = useDispatch();

  const user = useSelector(getUser);
  const subscription = useSelector(getSubscription);
  const products = useSelector(getProducts);
  const isLoadingSubscription = useSelector(getIsLoadingSubscription);

  const [isBuying, setIsBuying] = useState(false);

  const buy = useCallback((priceId, amount) => {
    if(user) {
      setIsBuying(true)
      const uid = user.uid;
      dispatch(initCheckout({priceId, uid}))
    }
  }, [user, dispatch])

  useEffect(() => {
    dispatch(fetchAllProducts())
  }, [dispatch])

  useEffect(() => {
    if(user) {
      dispatch(fetchSubscription())
    }
  }, [user, dispatch])

  const pricePerMonth = useCallback((price) => {

    return `$${price.amount / 100} / ${price.interval}`
  }, [])

  const paymentOptions = useCallback((price) => {
    if(price.interval === "year") {
      return "annually"
    } else {
      return "monthly"
    }
  }, [])

  if(isLoadingSubscription) {
    return (<div>
    </div>)
  }

  if(isBuying) {
    return (<Loader />)
  }

  return (<div className="mt-[2em]">
    <AccountDetails subscription={subscription} />
    {subscription ?
      <PaymentPortalLink /> :
      (<div>
        <p className="mt-[2em]">Upgrade to see your dream history:</p>
        {products ? products.map(p => {
            return <div key={p.name} className="flex-col">
              {p.prices.map((price, index) => {
                return (<div key={price.priceId} className="flex flex-col">
                  {index !== 0 ?
                    <span className="flex mx-auto">or</span> : ""
                  }
                  <button
                    onClick={() => buy(price.priceId, price.amount)}
                    className={`flex
                      ring ring-1 ring-[#FFFFFF]/[0.4]
                      rounded-full
                      h-[2.5em]
                      justify-center items-center
                      share-button
                      w-full
                      my-[10px]`}
                  >
                    <p>{pricePerMonth(price)} (paid {paymentOptions(price)})</p>
                  </button>
                </div>)
              })}
            </div>
          }) : ""}
        </div>)
      }
    </div>)

}

export default Pricing;
